module.exports = __webpack_public_path__ + "img/users-hover.0b31706a.svg";